import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PostHeader from '../post-header';
import PostTitle from '../post-title';
import ContentExcerpt from '../content-excerpt';
import PostImage from '../post-image';
import PostVideoEmbed from '../post-video-embed';
import ProtectedButton from '../../containers/protected-button';
import LikeButton from '../like-button';
import { HorizontalSeparator } from '../separator';
import withTranslate from '../../hoc/with-translate';
import getPostCover, { getPostVideoEmbedCover } from '../../services/get-post-cover';
import getOuterUrl from '../../services/get-outer-url';
import { getCategory } from '../../selectors/categories-selectors';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withEnvironment from '../../hoc/with-environment';
import withFontClassName from '../../hoc/with-font-class-name';
import withPermissions from '../../hoc/with-permissions';
import withAuth from '../../hoc/with-auth';
import styles from './post-list-item.scss';

const renderImage = (image, url, isPublic) => {
  return image && <PostImage image={image} url={url} isPublic={isPublic}/>;
};

const renderVideoEmbed = oembed => {
  return oembed && <PostVideoEmbed oembed={oembed}/>;
};

export const PostListItem = ({
  type,
  t,
  category,
  post,
  query,
  onLikeClick,
  borderWidth,
  titleFontClassName,
  contentFontClassName,
  can,
  navigation: { Link },
  forPublicUser,
}) => {
  const handleLikeClick = e => {
    e.preventDefault();
    onLikeClick(`${post._id}`);
  };
  const isSearch = type === PostListItem.SEARCH;
  let image = !isSearch && getPostCover(post.content);
  const videoEmbed = !isSearch && getPostVideoEmbedCover(post.content);
  const showSeparator = !image;
  const className = classNames(
    styles.container,
    styles[type],
    contentFontClassName,
    'forum-text-color',
    'forum-card-background-color',
    'forum-card-border-color',
    'post-list-item',
    { [styles.withImage]: image || videoEmbed }
  );
  const postLink = `/${category.slug}/${post.slug}`;
  const likeCount = post.likeCount || 0;

  if (videoEmbed) {
    image = undefined;
  }

  return (
    <Link
      className={className}
      to={postLink}
      style={{ borderWidth }}
      renderInSeo={false}
      role="article"
      data-hook="post-list-item"
    >
      <PostHeader type={type} post={post} showTopComment={true}/>
      <PostTitle className={titleFontClassName} type={type} title={post.title} query={query} to={postLink}/>
      <div className={styles.content}>
        <ContentExcerpt type={type} content={post.content} query={query}/>
      </div>
      {renderImage(image, getOuterUrl(postLink), can('share', 'post', post))}
      {renderVideoEmbed(videoEmbed)}
      <div className={styles.footer}>
        {showSeparator && <HorizontalSeparator className={styles.separator}/>}
        <div className={styles.footerContent}>
          <div
            className={classNames(styles.viewCount, 'post-list-item__view-count')}
            data-hook="post-list-item__view-count"
          >
            {t('post-list-item.view-count', { count: post.viewCount || 0 })}
          </div>
          <object type="communities/link">
            <Link
              className={classNames(styles.commentCount, 'forum-text-color')}
              to={`${postLink}`}
              data-hook="post-list-item__comment-count"
            >
              {t('post-list-item.total-comments', { count: post.totalComments || 0 })}
            </Link>
          </object>
          <ProtectedButton
            className={classNames(styles.likeButton, contentFontClassName)}
            onClick={forPublicUser(handleLikeClick, { preventDefault: true })}
            aria-live="assertive"
            data-hook="post-list-item__like-button"
          >
            <span className={classNames(styles.likeCount, 'forum-text-color')} data-hook="post-list-item__like-count">
              {t('post-list-item.like-count', { count: likeCount })}
            </span>
            <LikeButton isLiked={post.isLiked} likeCount={likeCount} isDisabled={post.isLikeInProgress}/>
          </ProtectedButton>
        </div>
      </div>
    </Link>
  );
};

PostListItem.SMALL = 'small';
PostListItem.MEDIUM = 'medium';
PostListItem.LARGE = 'large';
PostListItem.SEARCH = 'search';
PostListItem.MEMBERS_AREA = 'membersArea';

PostListItem.propTypes = {
  onLikeClick: PropTypes.func.isRequired,
  t: PropTypes.func,
  category: PropTypes.object,
  post: PropTypes.object.isRequired,
  query: PropTypes.string,
  type: PropTypes.string,
  borderWidth: PropTypes.number,
  titleFontClassName: PropTypes.string,
  contentFontClassName: PropTypes.string,
  can: PropTypes.func,
  navigation: PropTypes.object,
  forPublicUser: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  category: getCategory(state, ownProps.post.categoryId),
});

export default flowRight(
  connect(mapStateToProps),
  withCardBorderWidth,
  withEnvironment({ navigation: 'navigation' }),
  withFontClassName,
  withPermissions,
  withPermissions,
  withTranslate,
  withAuth,
)(PostListItem);



// WEBPACK FOOTER //
// ./app/components/post-list-item/post-list-item.js